window.confirm = (message, accept, declined) => {
    let target;

    /** Check if event object is available */
    if (event) {
        event.preventDefault();
        target = $(event.target);
    }
    let modal = $(target ? target.data('confirm-modal') ?? '#js-confirm-modal' : '#js-confirm-modal');
    let confirmed = false;
    modal.find('.modal-body .text').html(message);
    modal.find('button.confirm').click(function () {
        confirmed = true;

        if (accept) {
            accept();
            modal.modal('hide');
            return;
        }

        let form = target.closest('form')

        if (form.length) {
            form.submit();
            return;
        }

        if (target.is('a')) {
            window.location = target.click().attr('href');
        } else if (target.closest('a').length === 1) {
            window.location = target.closest('a').attr('href');
        }
        modal.modal('hide');
    });
    if (declined)
        modal.on('hide.bs.modal', function () {
            if (!confirmed) {
                declined();
            }
        })
    modal.modal('show');
};
